/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CompaniesApiService } from '@fleet-beat/api';
import { CompanyDto } from '@fleet-beat/core';
import { AuthService, CompanyStoreService } from '@fleet-beat/shared';
import { catchError, Observable, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompanyResolver implements Resolve<CompanyDto> {
  constructor(
    private companiesApiService: CompaniesApiService,
    private authService: AuthService,
    private companyStoreService: CompanyStoreService,
  ) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<CompanyDto> | Promise<CompanyDto> | CompanyDto {
    const companyId = route.paramMap.get('id');

    if (!companyId) {
      this.authService.signOut();
      return of(null);
    }
    return this.companiesApiService.getOne(companyId, this.authService.authHeaders).pipe(
      tap((company: CompanyDto) => {
        if (company) {
          this.companyStoreService.setCompany(company);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.authService.signOut();
        return of(null);
      }),
    );
  }
}
